export default __webpack_public_path__ + "static/media/mechanism_ratio.227dd23d.gif";